module.exports = __webpack_public_path__ + "static/media/fist_green_light.1a9dccc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/fist_green_light.svg
// module id = 356
// module chunks = 0